




















import { Vue, Component } from "vue-property-decorator";

import TheSimpleHeader from "@/common/components/organisms/TheSimpleHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import LocalStorage from "@/general/utils/storage";

@Component({
  components: {
    TheSimpleHeader,
    TheFooter,
    CommonHeading
  }
})
export default class TermsAndConditions extends Vue {
  terms = "";

  created() {
    // const allOrgAdminSettings = LocalStorage.getItem("orgAdminSettings")
    //   ? JSON.parse(LocalStorage.getItem("orgAdminSettings") as string)
    //   : [{}];
    // const orgAdminSettings = allOrgAdminSettings[0];

    // this.terms = orgAdminSettings.membership_term_url;

    const userDetails = LocalStorage.getItem("userDetails");
    if (userDetails) {
      const userDetailsJson = JSON.parse(userDetails);
      this.terms = userDetailsJson.membership_term_url;
    }
  }
}
